import React from 'react';
import './Contact.css';
// import { GrInstagram } from 'react-icons/gr';
// import { BsTwitterX } from 'react-icons/bs';

const Contact: React.FC = () => {
  return (
    <section className="contact" id="#contact">
      <div className="textbox">
        <h1 className="contact-title">Contact us today!</h1>
      </div>
      <div className="textbox">
        <div className="contact-details">
          <p className="contact-phone-prompt">Give us a call at:</p>
          <p className="contact-phone">0490 371 644</p>
          <p className="contact-email-prompt">Or email us at:</p>
          <p className="contact-email">hometemple@protonmail.com</p>
          {/* <p className="contact-socials-prompt">Follow us at:</p>
          <div className="contact-socials">
            <a href="https://www.instagram.com/hometemple_au/" target="_blank" rel="noreferrer noopener">
              <span className="social-icon">
                <GrInstagram />
              </span>
            </a>
            <a href="https://x.com/hometemple" target="_blank" rel="noopener noreferrer">
              <span className="social-icon">
                <BsTwitterX />
              </span>
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Contact;